import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/analytics/compare");

export const Route = createFileRoute("/analytics/compare")({
  head: () => ({
    meta: [
      { title: "Compare runs — LevelLoad" },
      { name: "description", content: "Compare runs — LevelLoad transport planning." },
      { property: "og:title", content: "Compare runs — LevelLoad" },
      { property: "og:description", content: "Compare runs — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
